export default __webpack_public_path__ + "static/media/Judge.c43b83c6.svg";